import { render, staticRenderFns } from "./HuchaTransferirStripeOk.vue?vue&type=template&id=11705ed0&scoped=true"
import script from "./HuchaTransferirStripeOk.vue?vue&type=script&lang=js"
export * from "./HuchaTransferirStripeOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11705ed0",
  null
  
)

export default component.exports